import { IconRepeat } from '@tabler/icons-react'

import { AstraIcon, AstraParagraph } from '~/astra'
import { RecurringAssignmentTypes } from '~/storm'

import { RecurringAssignment } from './RecurringAssignment'
import { RecurringAssignmentEmptyListImage } from './RecurringAssignmentEmptyListImage'
import { RecurringAssignmentFilteredListMessage, RecurringAssignmentFilters, useRecurringAssignmentFilters } from './RecurringAssignmentFilters'

const EmptyList = () => (
    <div className="flex flex-col items-center gap-8 p-8">
        <span className="bg-medium-rest rounded-full bg-magic-strong-rest p-2">
            <AstraIcon icon={IconRepeat} color="text-inverted" />
        </span>
        <AstraParagraph className="max-w-[320px] text-center text-muted">
            Kom i gang med å definere repeterende aktiviteter for utvalgte ressurser. For eksempel <i>Kveldspoliklinikk</i> hver andre torsdag.
        </AstraParagraph>
        <RecurringAssignmentEmptyListImage />
    </div>
)

export const RecurringAssignmentList = ({ recurringAssignments }: { recurringAssignments: RecurringAssignmentTypes }) => {
    const { filters, handleSetFilter, filteredAssignments, isAnyFilterActive, hiddenByFilterCount } = useRecurringAssignmentFilters(recurringAssignments)
    const showEmptyList = recurringAssignments.length < 1

    return (
        <div className="flex h-[45vh] w-[550px] flex-col items-stretch gap-4">
            {!showEmptyList && (
                <div className="relative z-elevated px-3">
                    <RecurringAssignmentFilters recurringAssignments={recurringAssignments} filters={filters} onFilterChange={handleSetFilter} />
                </div>
            )}
            <div className="flex flex-col items-stretch gap-4 overflow-auto px-3">
                {showEmptyList && <EmptyList />}
                {filteredAssignments.map(assignment => (
                    <RecurringAssignment key={assignment.uuid} assignment={assignment} />
                ))}
                {isAnyFilterActive && (
                    <RecurringAssignmentFilteredListMessage filteredAssignments={filteredAssignments} hiddenByFilterCount={hiddenByFilterCount} />
                )}
            </div>
        </div>
    )
}
